const WORDS = ["Fresh", "Hygienic", "Homemade", "Taste, Tradition and Celebration with Love", "Est. 2025", "Cloud Kitchen"];

export const Marquee = () => (
  <div className="bg-[#3D2314] py-4 overflow-hidden select-none" aria-hidden="true" data-testid="brand-marquee">
    <div className="animate-marquee flex whitespace-nowrap w-max">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center">
          {WORDS.concat(WORDS).map((w, i) => (
            <span key={`${copy}-${i}`} className="flex items-center">
              <span className="font-display italic text-[#FAF4EC] text-base sm:text-lg px-6">{w}</span>
              <span className="text-[#D86A7A] text-xs">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
